import { Client } from 'paho-mqtt';
import { noop } from 'util/index';
import { queryRequest, profile } from './client';
import { stationSubscription, scheduleSubscription } from './queries';
import Show from '../models/Show';

const MQTTCLIENT_SUCCESS = 0;

async function fetchSubscription(slug, query) {
  const subscriptionResponse = await queryRequest({
    query,
    variables: {
      slug,
      profile,
    },
    usePost: true,
  });

  return subscriptionResponse;
}

/**
 * Add subscription for stationEvent
 * @param {string} slug - Slug of a given station
 * @callback callback - A function to run if we had a successful fetching of tracks for given station
 * @callback errorCallback - A function to run if we get error
 * @returns {Client} client
 */
export const subscribeToStationEvents = async (slug, callback, errorCallback) => {
  try {
    const data = await fetchSubscription(slug, stationSubscription);

    const connection = data.extensions.subscription.mqttConnections[0];
    const client = new Client(connection.url, connection.client);

    client.connect({
      onSuccess() {
        client.subscribe(connection.topics[0]);
      },
    });

    client.onMessageArrived = ({ payloadString }) => {
      const payload = JSON.parse(payloadString);
      if (callback && payload && payload.data.stationEvent && payload.data.stationEvent.playouts) {
        callback(payload.data.stationEvent.playouts.map(({ track }) => track));
      }
    };

    client.onConnectionLost = (error) => {
      client.onMessageArrived = noop;
      client.onConnectionLost = noop;
      if (error.errorCode !== MQTTCLIENT_SUCCESS) {
        errorCallback({
          message: `mqtt connection lost | MQTTCLIENT errorCode: ${error.errorCode}`,
        });
      }
    };

    return client;
  } catch (error) {
    errorCallback(error);
  }
  return null;
};

/**
 * Add subscription for scheduleEvent
 * @param {string} slug- Slug of a given station
 * @callback callback - A function to run if we had a successful fetching of tracks for given station
 * @callback errorCallback- A function to run if we get error
 * @returns {Client} client
 */
export const subscribeToScheduleEvents = async (slug, callback, errorCallback) => {
  try {
    const data = await fetchSubscription(slug, scheduleSubscription);

    const connection = data.extensions.subscription.mqttConnections[0];
    const client = new Client(connection.url, connection.client);

    client.connect({
      onSuccess() {
        client.subscribe(connection.topics[0]);
      },
    });

    client.onMessageArrived = ({ payloadString }) => {
      const payload = JSON.parse(payloadString);
      if (callback && payload && payload.data.scheduleEvent && payload.data.scheduleEvent.schedule) {
        const {
          schedule: { show, broadcastStartDate, broadcastEndDate },
        } = payload.data.scheduleEvent;
        const liveShow = new Show({
          ...show,
          broadcastStartDate,
          broadcastEndDate,
        });
        callback(liveShow);
      }
    };

    client.onConnectionLost = (error) => {
      client.onMessageArrived = noop;
      client.onConnectionLost = noop;
      if (error.errorCode !== MQTTCLIENT_SUCCESS) {
        errorCallback({
          message: `mqtt connection lost | MQTTCLIENT errorCode: ${error.errorCode}`,
        });
      }
    };

    return client;
  } catch (error) {
    errorCallback(error);
  }
  return null;
};
